import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { SignedTimetable } from '@app/entities/models/mot/signed-timetables/signed-timetables.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

export interface SignedTimetablesUseCases {
  getSignedTimetables(): Observable<SignedTimetable[]>;
  getSignedTimetableByDocumentId(documentId: string): Observable<MSafeAny>;
  onError$: Observable<ErrorMsgEnum>;
}

export const SIGNED_TIMETABLES_USE_CASES = new InjectionToken<SignedTimetablesUseCases>('SIGNED_TIMETABLES_USE_CASES');
